import styled from '@emotion/styled'
import { ModalProps } from 'antd/lib/modal'
import { useCallback } from 'react'
import Button from '../../components/common/Button'
import Image, { ImageNameKeys } from '../../components/common/Image'
import Modal from '../../components/common/Modal'
import Text from '../../components/common/Text'
import colors from '../../constant/colors'
import { mobile } from '../../utils/responsive-helper'

const Layout = styled.div`
    padding: 24px;

  ${mobile} {
    width: calc(100vw - 32px);
    padding: 16px;
    padding-top: 24px;

    .header {
      padding-right: 32px;
    }
  }
`
const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;
`
const Content = styled.div`
  margin-bottom: 16px;
  border-radius: 8px;
`
const TextCenter = styled(Text)`
  text-align: center;
`
const ConfirmButton = styled(Button)`
  width: 200px;
`
const Footer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  background-color: ${colors.WHITE};
  padding: 16px;
  border-radius: 5px;
  column-gap: 16px;
`
type ModalRelativeDeleteProps = {
  icon?: ImageNameKeys
  errorMessage: string
  onConfirmClick: () => void
  onCloseClick: () => void
} & Required<Pick<ModalProps, 'visible'>>

const ModalRelativeDelete = (props: ModalRelativeDeleteProps) => {
  const { icon = null, errorMessage, visible, onConfirmClick, onCloseClick } = props

  const onCancel = useCallback(() => {
    onCloseClick()
  }, [onCloseClick])

  const onConfirm = useCallback(() => {
    onConfirmClick()
  }, [onConfirmClick])

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      style={{
        padding: 0,
      }}
      hideFooter
      hideCloseIcon
    >
      <Layout>
        <Header>
          {icon && <Image imageName={icon} width={72} height={72} />}
        </Header>
        <Content>
          <TextCenter size={16} type="Bold">{errorMessage}</TextCenter>
        </Content>
        <Footer>
          <ConfirmButton borderColor={colors.DARK_RED_PRIMARY} background={colors.DARK_RED_PRIMARY} onClick={onConfirm}>
            ยืนยัน
          </ConfirmButton>
          <ConfirmButton ghost borderColor={colors.DARK_RED_PRIMARY} fontColor={colors.DARK_RED_PRIMARY} onClick={onCancel}>
            ยกเลิก
          </ConfirmButton>
        </Footer>
      </Layout>
    </Modal>
  )
}

export default ModalRelativeDelete